var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['fixed-top', _vm.visible === false ? 'd-none':'']},[_c('div',{staticClass:"alert alert-warning preloader mx-auto m-2"},[_vm._v("Loading ...")])])}
var staticRenderFns = []

export { render, staticRenderFns }